var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { Button as StyledButton, SectionContainer } from '../styles';
export var Button = function (_a) {
    var section = _a.section;
    var theme = useTheme();
    var buttonOnClickHandler = function () { return window.open(section.link); };
    return (_jsx(SectionContainer, { children: _jsx(StyledButton, __assign({ onClick: buttonOnClickHandler, textColor: theme.textButtons, backgroundColor: theme.buttons }, { children: section.text }), void 0) }, void 0));
};
